import { useState } from "react";
import { Loader2, Undo2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { SecureGate } from "@/components/SecureGate";
import { api, errMsg } from "@/lib/api";

export function ReopenJobButton({ job, onDone }) {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try {
      await api.post(`/admin/jobs/${job.id}/reopen`);
      toast.success("Intervento riportato a 'da completare'");
      setOpen(false);
      onDone();
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <>
      <Button variant="outline" onClick={() => setOpen(true)} className="rounded-full border-amber-300 text-amber-700" data-testid="job-detail-reopen-button">
        <Undo2 className="h-4 w-4" /> Riapri intervento</Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="sm:max-w-md" data-testid="reopen-job-dialog">
          <DialogHeader><DialogTitle className="font-display">Riaprire l'intervento?</DialogTitle></DialogHeader>
          <SecureGate description="Inserisci la seconda password per riaprire un intervento completato. Resta sbloccata per 30 minuti.">
            <p className="text-sm text-slate-600">L'intervento torna "da completare"{job.technician_name ? ` e ${job.technician_name} riceve una notifica per richiuderlo` : ""}.
              Il rapporto attuale viene archiviato nello storico, foto e dati del cliente restano.</p>
            <DialogFooter>
              <Button variant="outline" className="rounded-full" onClick={() => setOpen(false)} data-testid="reopen-job-cancel">Annulla</Button>
              <Button className="rounded-full" onClick={run} disabled={busy} data-testid="reopen-job-confirm">{busy && <Loader2 className="h-4 w-4 animate-spin" />} Sì, riapri</Button>
            </DialogFooter>
          </SecureGate>
        </DialogContent>
      </Dialog>
    </>
  );
}
